<template xmlns="http://www.w3.org/1999/html">
  <div v-click-outside="hide" style="cursor: pointer;">
  <span class="adp-p adp-p__green" @click="toggle">
    {{ $t('idp.' + selected) }} <img src="/images/arrow_down.svg" alt="" class="arrow-icon">
  </span>
    <div v-if="isVisible">
      <div class="position-absolute adp-dd-options">
        <div class="d-flex flex-column">
          <div class="adp-p adp-dd-option d-flex justify-content-between align-items-center"
               @click="selected = option" v-for="(option, i) in options">
            <span class="apd-p" style="width: calc(100% - 32px);">{{ $t('idp.' + option) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MyTemplateFilter',
  props: {
    options: {
      type: Array,
      required: false,
    },
    initSelected: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selected: this.initSelected,
      isVisible: false,
    };
  },
  watch: {
    initSelected() {
      if(this.initSelected !== this.selected) {
        this.selected = this.initSelected;
      }
    },
    selected() {
      this.isVisible = false;
      this.$emit('my-change', this.selected);
    },
  },
  methods: {
    hide() {
      this.isVisible = false;
    },
    open() {
      this.isVisible = true;
    },
    toggle() {
      this.isVisible = !this.isVisible;
    },
  }
};
</script>

<style scoped>
>>> .adp-dd-options {
  max-width: 310px;
  min-width: 310px;
  left: 0;
}
>>> .arrow-icon {
  margin-left: 7px;
  transform: rotate(90deg);
}
</style>
